import MetricTimeUnit from './MetricTimeUnit'

const TimeUnitCategory = Object.freeze({
  OVER_1Y: 'Over1Year',
  OVER_3M: 'Over3Months',
  OVER_1M: 'Over1Month',
  OVER_1W: 'Over1Week',
  OVER_1D: 'Over1Day',
  OVER_1H: 'Over1Hour',
  UNDER_1H: 'Under1Hour'
})

type TimeUnitCategoryStrings = typeof TimeUnitCategory[keyof typeof TimeUnitCategory]

// /**
//  * @param {TimeUnitCategory} category
//  * @return {Array.<MetricTimeUnit>}
//  */
export const getOptions = (category: TimeUnitCategoryStrings) => {
  switch (category) {
    case TimeUnitCategory.OVER_1Y:
      return [MetricTimeUnit.MONTH, MetricTimeUnit.WEEK]

    case TimeUnitCategory.OVER_3M:
      return [MetricTimeUnit.MONTH, MetricTimeUnit.WEEK, MetricTimeUnit.DAY]

    case TimeUnitCategory.OVER_1W:
      return [MetricTimeUnit.WEEK, MetricTimeUnit.DAY]

    case TimeUnitCategory.OVER_1D:
      return [MetricTimeUnit.DAY, MetricTimeUnit.HOUR]

    case TimeUnitCategory.OVER_1H:
      return [MetricTimeUnit.HOUR, MetricTimeUnit.QUARTER_HOUR]

    case TimeUnitCategory.UNDER_1H:
    default:
      return [MetricTimeUnit.QUARTER_HOUR, MetricTimeUnit.MINUTE]
  }
}

export default TimeUnitCategory
